import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLLabelElement> {
  static targets = ['formWithPassword', 'formWithoutPassword']

  declare formWithPasswordTarget: HTMLFormElement
  declare formWithoutPasswordTarget: HTMLFormElement

  connect(): void {
    this.formWithoutPasswordTarget.classList.add('hidden')
  }

  toggleForm(e: MouseEvent): void {
    e.preventDefault()
    this.formWithPasswordTarget.classList.toggle('hidden')
    this.formWithoutPasswordTarget.classList.toggle('hidden')
  }
}
